export const ListQueryKey = 'letterRecords';
export const DetailQueryKey = 'letterRecord';

export const Urls = {
  selectUrl: '/letters/list',
  updateUrl: '/letters/update',
  deleteUrl: '/letters/delete',
  createUrl: '/letters/create',
  detailUrl: '/letters/detail',
};
